import {combineReducers} from 'redux';
import {makeAsyncReducer} from 'common/utils/simplifiedAsync';
import {bcErrorHandler} from 'bc/services/bcErrorCodes';
import * as actions from '../actions';
import {composeReducers} from '../../../common/utils/reducers';

const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};
const csvFormatAnalysis = makeAsyncReducer(actions.fetchS3CsvFormatAnalysis, {
  defaultData: EMPTY_ARRAY,
  errorHandler: bcErrorHandler,
});

export default combineReducers({
  csvFormatAnalysis,
  filePreview: composeReducers(
    makeAsyncReducer(actions.fetchS3Preview, {defaultData: EMPTY_OBJECT}),

    (state, {type}) => {
      switch (type) {
        case actions.setSelectedDataStream.TYPE:
          return {data: EMPTY_OBJECT};
        case actions.fetchS3CsvFormatAnalysis.success.TYPE:
          return {data: EMPTY_OBJECT};
        default:
          return state;
      }
    },
  ),
});
